module.exports = __webpack_public_path__ + "img/y-229.cda43531.png";